import {gsap} from "../lib/gsap";
import {Draggable} from "../lib/gsap/Draggable";
import {Flip} from "../lib/gsap/Flip";
import {Observer} from "../lib/gsap/Observer";
import {ScrollTrigger} from "../lib/gsap/ScrollTrigger";
import {SplitText} from "../lib/gsap/SplitText";

import Lenis from "../lib/lenis/lenis.esm.js";
import CircleType from "../lib/circletype/circletype.min.js";
import Matter from "../lib/matter/matter.min.js";
import MatterAttractors from "../lib/matter/matter-attractors.min.js";

gsap.registerPlugin(Draggable, Flip, Observer, ScrollTrigger, SplitText);

export {CircleType};
export {Draggable};
export {Flip};
export {Observer};
export {ScrollTrigger};
export {SplitText};
export {gsap};
export {Lenis};
export {Matter};
export {MatterAttractors};


